import {
  BulkActionActionConfirmationTabs,
  BulkActionItemID,
  BulkActionsStep,
  BulkActionsVariant,
} from "components/BulkActions/types";
import BulkActionsDrawerActionStepsFooter from "components/BulkActions/Drawer/ActionSteps/Footer";
import BulkActionsDrawerActionStepsConfirmation from "components/BulkActions/Drawer/ActionSteps/Confirmation";
import BulkActionsDrawerActionStepsConfirmationEmptyTab from "components/BulkActions/Drawer/ActionSteps/Confirmation/EmptyTab";

import IdpGroupRolesBulkActionsSelectedItem from "./SelectedRoleItem";
import IdpGroupRolesBulkActionsConfirmActionForm from "./ConfirmActionForm";
import {
  IdpGroupRolesBulkActionsAnalyticsPayload,
  IdpGroupRolesBulkActionsSelectedAction,
} from "./types";
import { IdpGroupRolesMutationVariables } from "./useIdpGroupRolesBulkActions/types";
import { RoleBinding } from "../types";

type IdpGroupRolesBulkActionsConfirmationViewProps = {
  applicableItems: RoleBinding[];
  skippedItems: RoleBinding[];
  onItemDismiss: (id: BulkActionItemID) => void;
  selectedBulkAction: IdpGroupRolesBulkActionsSelectedAction;
  onConfirm: (
    mutationVariables: IdpGroupRolesMutationVariables,
    analyticsPayload: IdpGroupRolesBulkActionsAnalyticsPayload
  ) => void;
  onCancel: () => void;
};

const IdpGroupRolesBulkActionsConfirmationView = ({
  applicableItems,
  skippedItems,
  onItemDismiss,
  selectedBulkAction,
  onConfirm,
  onCancel,
}: IdpGroupRolesBulkActionsConfirmationViewProps) => {
  const getItems = (tab: BulkActionActionConfirmationTabs) => {
    if (tab === BulkActionActionConfirmationTabs.Applicable) {
      return applicableItems;
    }

    return skippedItems;
  };

  return (
    <>
      <BulkActionsDrawerActionStepsConfirmation
        applicableCount={applicableItems.length}
        skippedCount={skippedItems.length}
      >
        {({ currentTab }) =>
          getItems(currentTab).length === 0 ? (
            <BulkActionsDrawerActionStepsConfirmationEmptyTab currentTab={currentTab} />
          ) : (
            getItems(currentTab).map((item) => (
              <IdpGroupRolesBulkActionsSelectedItem
                key={item.id}
                item={item}
                onDismiss={onItemDismiss}
                itemCategory={currentTab}
                step={BulkActionsStep.ActionConfirmation}
              />
            ))
          )
        }
      </BulkActionsDrawerActionStepsConfirmation>

      <BulkActionsDrawerActionStepsFooter>
        <IdpGroupRolesBulkActionsConfirmActionForm
          variant={BulkActionsVariant.Drawer}
          action={selectedBulkAction}
          onConfirm={onConfirm}
          onCancel={onCancel}
        />
      </BulkActionsDrawerActionStepsFooter>
    </>
  );
};

export default IdpGroupRolesBulkActionsConfirmationView;
